import * as api from "../../../helpers/api_helper";
import { POST_LOGIN } from "../../../helpers/url_helper";

export const Login = (data) => api.post(POST_LOGIN, data);